import { FC, SVGAttributes } from "react";

const CategoriesIcon: FC<SVGAttributes<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M0 0H32V32H0z"
        transform="translate(-16 -186) translate(16 186)"
      />
      <g
        stroke="#000"
        strokeWidth="2"
        transform="translate(-16 -186) translate(16 186) translate(5 5)"
      >
        <rect width="8" height="8" x="1" y="1" rx="1" />
        <rect width="8" height="8" x="13" y="1" rx="1" />
        <rect width="8" height="8" x="13" y="13" rx="1" />
        <rect width="8" height="8" x="1" y="13" rx="1" />
      </g>
    </g>
  </svg>
);

export { CategoriesIcon };
